import React, { useCallback, useEffect, useState } from "react";
//MUI
import { Box, Button, Container, Divider, Grid, Stack } from "@mui/material";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import UButton from "../../components/mui/UButton";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UAlertDialog from "../../components/mui/UAlertDialog";
import UTable from "../../components/mui/UTable";
import UDatePickers from "../../components/mui/UDatePickers";

import { API, PAGE } from "../../config";
import { fni18n } from "../../services/commonService";
import {
    getAPI
    ,fnCallPopUp
} from "../../services/commonService";
import USelectBox from "../../components/mui/USelectBox";
import AuthenticationService from "../../pages/auth/AuthenticationService";
import { useTranslation } from "react-i18next";

const columns = [
    { 
        field: 'id',
        headerName: '번호',
        width: 60,
        headerAlign: 'center',
        align: 'center',
        hide: true,
    },
    {
        field: 'date',
        headerName: '일자',
        width: 160,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'branch',
        headerName: '지점',
        width: 160,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'machId',
        headerName: '기기번호',
        width: 100,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'acntDes',
        headerName: '거래유형',
        width: 100,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'statusCdNm',
        headerName: '기기상태',
        width: 100,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'doorSt',
        headerName: '문상태', 
        width: 100,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'availYn',
        headerName: '사용여부', 
        width: 50,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'ur4',
        headerName: '모드', 
        width: 100,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'errCd',
        headerName: '에러코드',
        width: 50,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'errDes',
        headerName: '에러코드명',
        width: 100,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'atecErCd',
        headerName: '상세에러코드',
        width: 50,
        editable: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'button',
        headerName: '상세',
        sortable: false,
        width: 140,
        headerAlign: 'center',
        align: 'center',
        renderCell: (params) =>
        (
            <Button 
                style={{ fontSize: "13px", width: "80%", height: "80%",}}
                variant="outlined"
                color="inherit"
                onClick={()=>fnCallPopUp(PAGE.OPER.STATUS_POPUP+"/"+params.rows.machId,1350,800)}
            >
                fni18n('보기')
            </Button>
        ),
        hide: true,
    },
];

const date = new Date(); 
const now = date.toISOString().slice(0, 10);

export default function StatusPage(){
    const { t } = useTranslation();
    const userLoginId = AuthenticationService.getLoggedInUserID();
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [branchs, setBranch] = useState([]);
    const [machineNo, setMachineNo] = useState([]);
    const [retailers, setRetailers] = useState([]);
    const [search, setSearch] = useState({
        startDate : now,
        endDate : now,
        // machId : 'ALL',
        // branch : 'N/A',
    });
    const [list, setList] = useState([]);
    const [detail, setDetail] = useState({});
    const [errorPopupOpen, setErrorPopupOpen] = useState(false); // error dialog
    const [errorMsg, setErrorMsg] = useState(""); // api error message
    const [ machId, setMachId ] = useState();
    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
        try {
            await Promise.all([
                loadComboBoxBranchGroup(),
                loadComboBoxBranch()
            ]);
        } catch (e) {
            console.error('초기 로딩 실패:', e.message);
        }
        };
        getLoadData();
    }, []);

    useEffect(() => {
        if (!isFirstLoad) return;
        if (search.storeCd) {
            onButtonClick("조회");
            setIsFirstLoad(false);
        };
    }, [search]);

    const clearSearchVal = ()=>{
        setSearch({
            ...search,
            ['branch']: 'N/A',
        });
        setMachineNo([])
    }

    // 콤보박스 데이터
    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRetailers(_inputData);
            // await loadComboBoxBranch(_inputData[0].cd);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxBranch = async (param) => {
        try{
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId,bizTy:param });
            const _inputData = res.data.result.map((m) => ({
                    cd: m.storeCd,
                    name: m.storeNm,
                })
            );
            setBranch(_inputData );
            if (_inputData.length > 0) {
                setSearch({
                    ...search,
                    ['branch'] :_inputData[0].cd,
                })
                await loadComboBoxMachineNo(_inputData[0].cd);
            } else {
                clearSearchVal()
            }
        }catch(e){
            console.error(e.message);
        }
    }; 
    const loadComboBoxMachineNo = async (branch) => {
        try{
            const res = await getAPI(API.COMMON.MACHINE+branch);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.machId,
                    name: m.machId + " - " + m.machNm,
                })
            );
            setMachineNo(_inputData );
        }catch(e){
            console.error(e.message);
        }
    };
    //DataGrid에서 row 선택 시 
    function onSelectedRow(row){
        setDetail(row); //Detail에 데이터 적용
    };

    //value 속성으로만 값을 컨트롤 할 수 있어서 
    //onChange를 써서 element를 수정할 수 있는 상태로 만듦
    const onDetailChange = (e) => {
        const { name, value } = e.target;
        setDetail({
            ...detail,
            [name]: value,
        });
    };

    const handleErrorOpen = () => {
        setErrorPopupOpen(true);
    };
    const handleErrorClose = () => {
        setErrorPopupOpen(false);
    };
    
    //검색조건 값 변경되었을 때
    const onSearchChange = async (e) => {
        const {name, value} = e.target;
        setSearch({
            ...search,
            [name] :value,
        })
        if (name === "bizTy") {
            await loadComboBoxBranch(value);
        }
        if(name=='branch'){
            await loadComboBoxMachineNo(value);
        }
        if(name=='machId'){
            setMachId(value)
        }
    }

    const onCheckboxChange = (e) => {
        setDetail({
          ...detail,
          [e.target.name]: e.target.checked === true ? "Y" : "N",
        });
    };
    async function onButtonClick(dvsn){

        if(dvsn==="조회"){
            await getAPI(API.OPER.STATUS_MACHINE, search).then((res) =>{
                if (res.data.code === 200) {
                    setList(res.data.result);
                } else {
                    setErrorMsg(t("처리가 실패하였습니다"));
                    handleErrorOpen();
                }
            })
        }else {
            setErrorMsg(t("알 수 없는 오류가 발생하였습니다"));
            handleErrorOpen();
        }
    };

    return(
        <div className="main-container">
            <Box className="header">
                <Grid container>
                    <Grid item xs={11}>
                        {/* 상단메뉴명 */}
                        <UBreadCrumbs
                            title={"기기정보"}
                            subtitle={"기기상태"}
                        />
                    </Grid>
                    <Grid item xs={1}>
                        {/* 툴바 버튼 */}
                        <Stack 
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            spacing={0.5}
                        >
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
        
            {/* 조회조건 */}        
            <div className="contents">
                <Box>
                    <TableContainer className="table-container">
                    <Table className="table" size="small">
                        <TableBody>
                            <TableRow className="table-row-header">
                                <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                                <TableCell className="table-cell">
                                    <USelectBox
                                        name="bizTy"
                                        items={retailers}
                                        onItemChange={onSearchChange}
                                    />
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                                <TableCell className="table-cell">
                                    {/* 점번선택 */}
                                    <USelectBox
                                        id="branch"
                                        name="branch"
                                        items={branchs}
                                        defaultValue={search.branch}
                                        onItemChange={onSearchChange}/>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                                <TableCell className="table-cell">
                                    {/* 기번선택 */}
                                    <USelectBox
                                        id="machId"
                                        name="machId"
                                        items={machineNo}
                                        onItemChange={onSearchChange}/>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n('일자')}</TableCell>
                                <TableCell className="table-cell" colspan={3}>
                                    {/* 조회기간 선택 */}
                                    <UDatePickers onChange={onSearchChange} startDate={now} endDate={now}/>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    </TableContainer>
                    <div className="search">
                        <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
                    </div>
                </Box>
            
                {/* 조회 리스트 */}
                <UTable columns={columns} rows={list} rowPerPage={11}/>
                
                {/* 조회 리스트 선택 상세  */}
                <UAlertDialog
                    message={errorMsg}
                    open={errorPopupOpen}
                    onClose={handleErrorClose}
                />
            </div>
        </div>
        

    );
}